module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-box"
  }, [_c('div', [(_vm.order.canceled) ? [_c('div', {
    staticClass: "small"
  }, [_vm._v("Заказ отменен")]), _vm._v(" "), _vm._m(0)] : [_c('div', {
    staticClass: "small",
    class: 'text-' + _vm.order.status.class
  }, [_vm._v(_vm._s(_vm.order.status.name))]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-md mt-h mb-1"
  }, [_c('div', {
    staticClass: "progress-bar",
    class: 'bg-' + (_vm.order.problem ? 'danger' : _vm.order.status.class),
    style: ({
      width: _vm.progressBarWidth + '%'
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])], _vm._v(" "), _c('div', [(_vm.loading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": false
    }
  }) : _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, _vm._l((_vm.order.transitions), function(transition) {
    return _c('b-btn', {
      key: transition.code,
      attrs: {
        "size": "md",
        "variant": _vm.getTransitionClass(transition),
        "disabled": (transition.code === 'accept' || transition.code === 'acceptFromConfirmed') && !_vm.todayCheck
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.beforeSetOrderTransition(transition)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "title": (transition.code === 'accept' || transition.code === 'acceptFromConfirmed') && !_vm.todayCheck ? 'В работу можно перевести только заказы на сегодня или просроченные' : ''
      }
    }, [_vm._v("\n                    " + _vm._s(transition.name) + "\n                  ")])])
  }))], 1)], 2), _vm._v(" "), (_vm.showSum) ? _c('div', [(_vm.order.sum) ? _c('div', [_vm._v("Выручка: "), _c('b', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.order.sum))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-rub"
  })]) : _vm._e(), _vm._v(" "), (_vm.order.profit) ? _c('div', [_vm._v("Прибыль: "), _c('b', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.order.profit))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-rub"
  }), _vm._v(" "), (_vm.commission !== -1) ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    class: {
      'commission-warn': _vm.commission < 10
    },
    attrs: {
      "title": "Рентабельность заказа"
    }
  }, [_vm._v("(" + _vm._s(_vm.commissionShow) + "%)")]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress progress-md mt-h mb-1"
  }, [_c('div', {
    staticClass: "progress-bar bg-canceled",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01c62a81", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-01c62a81"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Orders/OrderStatus.vue
// module id = 992
// module chunks = 1